import { baseUrl, baseUrlQA, baseUrlRela } from './baseURL'
import axios from './interceptors'
//问答
export function questionAnswer(data) {
  return axios.post(baseUrlQA + 'api/qa/questionAnswer', data)
}
// 知识库
export function matchSearch(data) {
  return axios.post(baseUrl + 'v2/search/fullTextSearch', data)
}
// 谥号解读
export function queryPosthumousTitle(data) {
  return axios.get(baseUrlRela + `mcwmzstpzsk/instance/queryChuKingYihao/${data}`)
}
// 土地官司
export function queryLandLitigation(data) {
  return axios.get(baseUrlRela + `mcwmzstpzsk/instance/queryLandLitigation/${data}`)
}
// 九座墓园
export function queryCemetery(data) {
  return axios.get(baseUrlRela + `mcwmzstpzsk/instance/queryChuCemetery/${data}`)
}
// 历史景观
export function queryLandscape(data) {
  return axios.post(baseUrlRela + 'mcwmzstpzsk/instance/queryInstancePageByTag', data)
}
// 图谱相关
export function queryNode(data) {
  return axios.post(baseUrlRela + 'v2/graph/queryTriples', data)
}
// 出土文物
export function queryPatrimony(data) {
  return axios.post(baseUrlRela + 'v2/resource/queryFileByConCeptCode', data)
}
// 出土文物-图片接口
export function queryPatrimonyImg(data) {
  return axios.post(baseUrlRela + `v2/resource/queryFileInfoByTagName`, data)
}
export function queryPath(data) {
  return axios.post(baseUrlRela + 'v2/graph/queryPath', data)
}
export function queryNodeLabel(data) {
  let headers = {
    h: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Allow-Origin': '*'
    }
  }
  let datas = new URLSearchParams()
  datas.append('instanceId', data.instanceId)
  return axios.post(baseUrlRela + 'api/graphNode/queryNodeLabel', datas, headers)
}
// 查询个人简介
export function queryInstanceDetails(data) {
  return axios.post(baseUrlRela + 'v2/instance/queryInstanceDetails', data)
}
export function queryInstanceRel(data) {
  return axios.post(baseUrlRela + 'v2/graph/queryInstanceRel', data)
}
export function querySortedInstanceNameList() {
  return axios.get(baseUrlRela + 'v2/instance/querySortedInstanceNameList', {})
}
// 知识百科
export function queryListQuick(data) {
  return axios.post(baseUrlRela + 'v2/instance/queryList', data)
}
export function queryListQuickV2(data) {
  return axios.post(baseUrlRela + 'v2/instance/queryListV2', data)
}
export function queryInstanceDetailsV2(data) {
  return axios.get(`${baseUrlRela}v2/instance/queryInstanceDetailsV2?instanceId=${data.instanceId}`)
}
// 楚王生平
export function queryBiography(data) {
  return axios.get(baseUrlRela + `mcwmzstpzsk/instance/queryBiography/${data}`)
}

// 楚国渊源
export function queryOrigin(data) {
  return axios.get(baseUrlRela + `mcwmzstpzsk/instance/queryChuKing/${data}`)
}

// 古代名人
export function queryCelebrity(data) {
  return axios.post(baseUrlRela + 'v2/instance/queryInstanceByTagAndAttr', data)
}

// 明楚简史
export function queryInstanceByTagParams(data) {
  return axios.post(baseUrlRela + 'v2/instance/queryInstanceByTagParams', data)
}

// 查询概念
export function queryChildTopics(data) {
  return axios.post(baseUrlRela + `topic/queryChildTopics/${data}`)
}

// 查询前言内容
export function queryPreface(data) {
  return axios.post(baseUrlRela + `topic/queryChildTopics/${data}`)
}

// 查询栏目内容
export function queryTopic(data) {
  return axios.get(baseUrlRela + `topic/queryTopicByTopicNumber/${data}`)
}

// 龙泉四季
export function queryFileInfoResourceByTagName(data) {
  return axios.post(baseUrlRela + 'v2/resource/queryFileInfoResourceByTagName', data)
}

// 根据素材id查询相关实例
export function queryInstanceDetailByMaterialId(data) {
  return axios.get(baseUrlRela + `v2/instance/queryInstanceDetailByMaterialId/${data}`)
}
